import Styled from './styled'
import { useTranslate } from 'hooks/translate'
// Components
import Table from 'components/Table'

import { useStoreState } from 'easy-peasy'
import { useMemo, useState, useEffect } from 'react'
import _ from 'lodash'
import { Typography } from 'antd'
import { useHistory } from 'react-router'

export default function IncidentTable ({ loading, dataSource, filters, onChange }) {
  const [total, setTotal] = useState(0)
  const { reportAttribute } = useStoreState((store) => store.monthlyDashboard)
  const { reportStatuses } = useStoreState((state) => state.filter)
  const history = useHistory()
  const { t } = useTranslate()
  const columns = useMemo(() => {
    return [
      {
        title: t('Report Code'),
        dataIndex: 'reportCodeCd',
        key: 'reportCodeCd',
        className: 'bold',
        render: (text, record, index) => {
          return (
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => {
                const href = history.createHref({
                  pathname: `incident-report/${record.reportTypeId}/${record.reportHeaderId}`,
                })
                window.open(href, '_blank')
              }}
            >
              {text}
            </div>
          )
        },
      },
      {
        title: t('Investigate Code'),
        dataIndex: 'investigateCodeCd',
        key: 'investigateCodeCd',
        className: 'bold',
      },
      {
        title: t('Report Date'),
        dataIndex: 'reportDate',
        key: 'reportDate',
        className: 'bold',
      },
      {
        title: t('Risk Coordinator'),
        dataIndex: 'riskCoordinator',
        key: 'riskCoordinator',
        className: 'bold',
      },
      {
        title: t('Incident Topic'),
        dataIndex: 'incidentTopic',
        key: 'incidentTopic',
        className: 'bold',
      },
      {
        title: t('Risk Owner'),
        dataIndex: 'riskOwnerOrgName',
        key: 'riskOwnerOrgName',
        className: 'bold',
        render: (text) => {
          const reg = /\n?\\n/g
          text = text || ''
          return text.split(reg).map((item, idx) => {
            return (
              <span key={idx}>
                <Typography.Text>{item}</Typography.Text>
                <br />
              </span>
            )
          })
        },
      },
      {
        title: t('Risk Level'),
        dataIndex: 'riskLevelName',
        key: 'riskLevelName',
        className: 'is-status',
        width: 150,
        render: (text, record, index) => {
          return (
            <div className='status-block' style={{ background: record.riskLevelColorName }}>
              <Typography.Text>{text}</Typography.Text>
            </div>
          )
        },
      },
      {
        title: t('Significant'),
        dataIndex: 'isSignificant',
        key: 'isSignificant',
        className: 'bold',
        width: 150,

        render: (data) => {
          return data ? 'Yes' : 'No'
        },
      },
      {
        title: t('Report status'),
        dataIndex: 'reportStatusId',
        key: 'reportStatusId',
        className: 'bold',
        render: (text) => {
          return reportStatuses.find((item) => item.id === text)?.name || ''
        },
      },
      {
        title: t('AP status'),
        dataIndex: 'apStatus',
        key: 'apStatus',
        className: 'bold',
      },
      ...reportAttribute.map(({ label, value }) => {
        return {
          title: t(label),
          dataIndex: 'reportAttributeValue',
          key: 'reportAttributeValue',
          className: 'bold',
          width: 180,
          render: (item) => {
            console.log(label)
            console.log(item)
            const result = item.find(
              (test) => test.report_type_attribute.report_type_attribute_name == label
            )
            // const format = () => {
            //   const num = Number(result?.report_type_attribute_investigate_value)
            //   return _.isNaN(num) ? 0 : new Intl.NumberFormat(undefined,{maximumFractionDigits: 2}).format(num)
            // }
            return result?.report_type_attribute_investigate_value &&
              result.report_type_attribute.is_dashboard == true
              ? result?.report_type_attribute_investigate_value
              : 'No Data'
          },
        }
      }),
    ]
  }, [t, reportAttribute, reportStatuses])
  useEffect(() => {
    if (!_.isEmpty(dataSource)) {
      setTotal(dataSource.total)
    }
  }, [dataSource])
  return (
    <Styled className='incident-bar-component'>
      {dataSource?.items ? (
        <Table
          pagination={{
            current: filters.page,
            pageSize: filters.size,
            total,
            showQuickJumper: true,
            showSizeChanger: true,
            showTotal: (total) => t('Total ${total} items', { total }),
          }}
          columns={columns}
          loading={loading}
          dataSource={dataSource?.items}
          onChange={onChange}
          scroll={{ x: 'max-content' }}
          sticky
          // onRow={(record) => {
          //   return {
          //     onClick: () => {
          //       const href = history.createHref({
          //         pathname: `incident-report/${record.reportTypeId}/${record.reportHeaderId}`,
          //       })
          //       window.open(href, '_blank')
          //     },
          //   }
          // }}
        ></Table>
      ) : null}
    </Styled>
  )
}
